import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Tab, Nav, Badge, Dropdown, Button, Carousel } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import moment from 'moment';
import "./Pricebook.css";
import View from '../../../modal/Purchase_Management/Manage_Pricebook/ViewPricebook';
import Select from "react-select";
import LightGallery from 'lightgallery/react';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios';

const Pricebook = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [key, setKey] = useState(2);
    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);
    const [open, setOpen] = useState(false);
    const [vendorList, setVendorList] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(2);
    const [index, setIndex] = useState(0);
    const [months, setMonths] = useState([]);
    const [apiData, setApiData] = useState({ data: {}, graph_data: [] });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');

    const [currentDate, setCurrentDate] = useState(new Date());

    const [selectedGraphItem, setSelectedGraphItem] = useState(null);
    const [graphData, setGraphData] = useState([]);
    const [loadingGraph, setLoadingGraph] = useState(false);

    const handleModalToggle = (item) => {
        setModalType("View");
        setSelectedGraphItem(item);
        setOpen(true);
    };

    useEffect(() => {
        if (open && selectedGraphItem) {
            setLoadingGraph(true);

            axios.get(`${baseURL}/vendor_pricebook_graph_yearly`, {
                params: {
                    vendor_id: selectedVendor,          // Make sure this state exists or adjust accordingly
                    raw_material_id: selectedGraphItem.raw_material_id,
                }
            })
            .then(response => {
                // API returns a single object, wrap in array for ViewPricebook compatibility
                setGraphData([response.data]);
            })
            .catch(error => {
                console.error("Failed to fetch graph data", error);
                setGraphData([]);
            })
            .finally(() => {
                setLoadingGraph(false);
            });
        }
    }, [open, selectedGraphItem, selectedVendor]);

    const onInit = () => {};

    useEffect(() => {
        const startYear = 2020;
        const endYear = 2030;
        const generatedMonths = [];
        for (let y = startYear; y <= endYear; y++) {
            for (let m = 0; m < 12; m++) {
                generatedMonths.push({
                    label: moment({ year: y, month: m }).format('MMMM'),
                    year: y,
                    month: m,
                });
            }
        }
        const currentMonth = moment();
        const currentIndex = generatedMonths.findIndex(m => m.year === currentMonth.year() && m.month === currentMonth.month());
        setMonths(generatedMonths);
        setIndex(currentIndex !== -1 ? currentIndex : 0);
    }, []);


    const fetchVendorPricebook = async () => {
        try {
            const params = new URLSearchParams({
                vendor_id: selectedVendor,
                month: currentDate.getMonth() + 1,
                year: currentDate.getFullYear(),
                page,
                per_page: perPage,
                search: searchTerm
            });

            const res = await fetch(`${baseURL}/pricebook?${params.toString()}`);
            const json = await res.json();

            setApiData(json);
            setTotalCount(json.total || 0);
            setTotalPages(json.last_page || 1); // for Laravel-style pagination
        } catch (err) {
            console.error("Error fetching pricebook:", err);
        }
    };

    useEffect(() => {
        if (selectedVendor && currentDate) {
            fetchVendorPricebook();
        }
    }, [selectedVendor, currentDate, page, perPage, searchTerm]);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    useEffect(() => {
        fetch(`${baseURL}/managevendor/vendors/active?branch_id=${branch_id}`,)
            .then((res) => res.json())
            .then((data) => {
                if (data.vendors) {
                    const options = data.vendors.map((vendor) => ({
                        value: vendor.sno,
                        label: vendor.vendor_businessname,
                    }));
                    setVendorList(options);
                }
            })
            .catch((err) => console.error("Error fetching vendors:", err));
    }, []);

    const generateDateHeaders = () => {
        const start = moment(currentDate).startOf('month');
        const end = moment(currentDate).endOf('month');
        const days = [];
        for (let m = start.clone(); m.isSameOrBefore(end); m.add(1, 'days')) {
            days.push({
                date: m.format('YYYY-MM-DD'),
                label: m.format('DD/MM'),
                day: m.format('ddd'),
            });
        }
        return days;
    };

    const dateHeaders = generateDateHeaders();

    const formatMonthYear = (date) => {
        return date.toLocaleString('default', { month: 'long', year: 'numeric' });
    };

    const handlePreviousMonth = () => {
        const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        setCurrentDate(prevMonth);
        // Call your fetch function here, e.g., fetchDataForMonth(prevMonth)
    };

    const handleNextMonth = () => {
        const today = new Date();
        const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);

        // Disable if nextMonth is after current month/year
        if (
            nextMonth.getFullYear() < today.getFullYear() ||
            (nextMonth.getFullYear() === today.getFullYear() && nextMonth.getMonth() <= today.getMonth())
        ) {
            setCurrentDate(nextMonth);
            // fetchDataForMonth(nextMonth); // if needed
        }
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Pricebook</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase Management</li>
                    </ol>
                </div>
                <div className='d-flex'>

                    {open && modalType === "View" && (
                        <View
                            show={open}
                            onClose={() => setOpen(false)}
                            item={selectedGraphItem}
                            // graphData={apiData.graph_data}
                            graphData={graphData}
                            month={currentDate.getMonth() + 1}
                            year={currentDate.getFullYear()}
                            vendorName={vendorList.find(v => v.value === selectedVendor)?.label || ''}
                            loading={loadingGraph}
                        />
                    )}


                </div>
            </div>

            <div className="table-container">
                <div className='row mb-3'>
                    <div className='col-lg-3'>
                        <label className="text-black font-w500 fs-7">Vendor<span className="required">*</span></label>
                        <Select
                            value={vendorList.find(option => option.value === selectedVendor) || null}
                            onChange={(selectedOption) => setSelectedVendor(selectedOption.value)}
                            options={vendorList}
                            placeholder="Select Vendor"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                            }}
                        />
                    </div>
                    {/* <div className='col-lg-7 d-flex align-items-end justify-content-between'>
                        <div className='mb-3 w-50'>
                            <Carousel
                                controls={true}
                                activeIndex={index}
                                onSelect={setIndex}
                                indicators={true}
                                interval={null}
                                className="custom-carousel"
                            >
                                {months.map((m, i) => (
                                    <Carousel.Item key={i} className='text-center'>
                                        <label className='fs-3 text-black fw-bold me-3'>{m.label}</label>
                                        <label className='fs-3 text-danger fw-bold'>{m.year}</label>
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </div>
                    </div> */}

                    <div className='col-md-6 d-flex align-items-center'>
                        <div className="d-flex align-items-center">
                        <button className="btn btn-sm  me-2" onClick={handlePreviousMonth}>
                            <i className="fa-solid fa-chevron-left fs-4"></i>
                        </button>
                        <span className="fw-bold fs-3 text-red">{formatMonthYear(currentDate)}</span>
                        <button className="btn btn-sm  ms-2" onClick={handleNextMonth} disabled={new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1) > new Date(new Date().getFullYear(), new Date().getMonth(), 1)}>
                            <i className="fa-solid fa-chevron-right fs-4"></i>
                        </button>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className="table-container">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Left: Show entries dropdown */}
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{  fontSize: '0.85rem', height: '30px' }}
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value));
                                        setPage(1); // Reset to first page
                                    }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>

                            {/* Right: Search input */}
                            <div>
                                <input
                                    type="text"
                                    style={{  fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1); // Reset page on new search
                                    }}
                                />
                            </div>
                        </div>
 
                        {/* Styles */}
                        <style>
                        {`
                            .scrollable-table-wrapper {
                            overflow-x: auto;
                            width: 100%;
                            }

                            table {
                            border-collapse: separate;
                            border-spacing: 0;
                            table-layout: auto;
                            }

                            .sticky-col {
                            position: sticky;
                            left: 0;
                            background: #ffffff;
                            z-index: 4;
                            }

                            thead .sticky-col {
                            background: #025D3A;
                            color: #fff;
                            z-index: 5;
                            }

                            tbody tr td {
                            background: #ffffff;
                            }

                            tbody tr:nth-child(even) td {
                            background: #f7f7f7;
                            }
                        `}
                        </style>
 
                        <div className="scrollable-table-wrapper">
                            <table className="attendance_table sticky_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-50px text-start text-black sticky-col'>Raw material/Category</th>
                                        <th className='min-w-50px text-black text-center'>Qty/Units</th>
                                        {dateHeaders.map((d, idx) => (
                                        <th key={idx} className="min-w-80px px-1 text-center">{d.label}<br />{d.day}</th>
                                        ))}
                                        <th className='min-w-50px text-center'>Action</th>
                                    </tr>
                                </thead>

                                {/* <tbody className="text-gray-600 fw-semibold fs-7">
                                    {Object.keys(apiData.data).length > 0 ? (
                                        Object.entries(apiData.data).flatMap(([date, items]) =>
                                            items.map((item, i) => (
                                                <tr key={`${date}-${i}`}>
                                                    <td className="sticky-col">
                                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                                            <div className="avatar-preview">
                                                                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                <div data-src={item.image_url} className='border rounded px-1 py-0'>
                                                                    <img src={item.image_url} alt={item.raw_material_name} className='cursor-pointer w-45px h-45px' />
                                                                </div>
                                                                </LightGallery>
                                                            </div>
                                                            <div>
                                                                <label className='text-black font-w600 fs-7'>{item.raw_material_name}</label>
                                                                <div>
                                                                <label className="fs-8 text-danger fw-bold">{item.category_name}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td className='text-center'>
                                                        <Badge bg="warning" className='py-0 px-2 fs-8'>{item.per_quantity} {item.unit_name}</Badge>
                                                    </td>

                                                    {dateHeaders.map((d, idx) => (
                                                        <td key={idx} className="min-w-80px px-1 text-center dt-type-numeric">
                                                            {d.date === date ? (
                                                                <>
                                                                    <span className='font-w600 text-black fs-7'>
                                                                        <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                                                        {item.per_amount}
                                                                    </span>
                                                                    {item.price_trend === 1 && (
                                                                        <i class="fas fa-arrow-up text-primary ms-2 fs-5 font-w600"></i>
                                                                    )}
                                                                    {item.price_trend === 2 && (
                                                                        <i class="fas fa-arrow-down text-danger ms-2 fs-5 font-w600"></i>
                                                                    )}
                                                                    {item.price_trend === 3 && (
                                                                        <i class="fas fa-arrows-v text-info ms-2 fs-5 font-w600"></i>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <span>-</span>
                                                            )}
                                                        </td>
                                                    ))}

                                                    <td className="text-center">
                                                        <OverlayTrigger
                                                        trigger={['hover', 'focus']}
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip className='toltip-popover'>
                                                            <span className='fs-8 text-white fw-semibold'>View</span>
                                                            </Tooltip>
                                                        }
                                                        >
                                                            <Button variant="tp-btn-light px-2 py-1 me-1" 
                                                                onClick={() => handleModalToggle(item)}
                                                                style={{ color: 'black' }}>
                                                                    <i className="fa fa-eye fs-6 mt-1"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                    ) : (
                                        <tr><td colSpan={dateHeaders.length + 3} className='text-center text-muted'>No data found.</td></tr>
                                    )}
                                </tbody> */}

                                <tbody>
                                    {Object.keys(apiData.data).length > 0 ? (
                                        <>
                                            {apiData.data.map((item, i) => (
                                                <tr key={item.raw_material_id}>
                                                    <td className="sticky-col">
                                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                                            <div className="avatar-preview">
                                                                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                <div data-src={item.image_url} className='border rounded px-1 py-0'>
                                                                    <img src={item.image_url} alt={item.raw_material_name} className='cursor-pointer w-45px h-45px' />
                                                                </div>
                                                                </LightGallery>
                                                            </div>
                                                            <div>
                                                                <label className='text-black font-w600 fs-7'>{item.raw_material_name}</label>
                                                                <div>
                                                                    <label className="fs-8 text-danger fw-bold">{item.category_name}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td className=''>
                                                        <Badge className='py-0 px-2 fs-8'>{item.per_quantity} {item.unit_name}</Badge>
                                                    </td>

                                                    {apiData.date_headers.map((date, idx) => {
                                                        const priceEntry = item.prices[date];
                                                        return (
                                                        <td key={idx} className="min-w-80px px-1 text-center dt-type-numeric">
                                                            {priceEntry ? (
                                                            <>
                                                                <span className='font-w600 text-black fs-7'>
                                                                <i className="fa-solid fa-indian-rupee-sign me-1"></i>
                                                                {priceEntry.per_amount}
                                                                </span>
                                                                {priceEntry.price_trend === 1 && (
                                                                <i className="fas fa-arrow-up text-primary ms-2 fs-5 font-w600"></i>
                                                                )}
                                                                {priceEntry.price_trend === 2 && (
                                                                <i className="fas fa-arrow-down text-danger ms-2 fs-5 font-w600"></i>
                                                                )}
                                                                {priceEntry.price_trend === 3 && (
                                                                <i className="fas fa-arrows-v text-info ms-2 fs-5 font-w600"></i>
                                                                )}
                                                            </>
                                                            ) : (
                                                            <span>-</span>
                                                            )}
                                                        </td>
                                                        )
                                                    })}

                                                    <td className="text-center">
                                                        <OverlayTrigger
                                                        trigger={['hover', 'focus']}
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip className='toltip-popover'>
                                                            <span className='fs-8 text-white fw-semibold'>View</span>
                                                            </Tooltip>
                                                        }
                                                        >
                                                        <Button variant="tp-btn-light px-2 py-1 me-1" 
                                                            onClick={() => handleModalToggle(item)}
                                                            style={{ color: 'black' }}>
                                                            <i className="fa fa-eye fs-6 mt-1"></i>
                                                        </Button>
                                                        </OverlayTrigger>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <tr>
                                            <td colSpan={3} className='text-center text-muted'>No data found.</td>
                                            <td colSpan={dateHeaders.length} className='text-center text-muted'>No data found.</td>
                                        </tr>
                                    )}
                                </tbody>



                            </table>
                        </div>


                        {/* <div className="d-flex justify-content-between align-items-center mt-3">
                            
                            <div>
                                {Array.isArray(apiData.data) && apiData.data.length > 0 ? (
                                    <span className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + apiData.data.length} of {TotalCount} entries
                                    </span>
                                ):(
                                    <span className="text-muted">
                                        Showing 0 to 0 of 0 entries
                                    </span>
                                )}
                            </div>

                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                    </li>
                                    ))}
                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>

                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Pricebook;